import React from 'react'
// import DealMaking from '../DealMaking/DealMaking'
import { DealMaking } from '@themed-components';
// import DealConcluded from '../DealConcluded/DealConcluded'
import { DealConcluded } from '@themed-components';
import TournamentPrizeDrawer from '../TournamentPrizeDrawer/TournamentPrizeDrawer'
import { 
  useShowDealICMPayoutDistribution,
  useShowDealConclusionPopup 
} from '@/src/hooks/data/useGameTable';
import TournamentEliminationDrawer from '../TournamentEliminationDrawer/TournamentEliminationDrawer';

export default function TourneyGameTableUI({ tempTableId }) {
    const showDealICMPayoutDistribution = useShowDealICMPayoutDistribution(tempTableId);
    const showDealConclusionPopup = useShowDealConclusionPopup(tempTableId);

    return (
        <>
            <TournamentEliminationDrawer tempTableId={tempTableId} />
            <TournamentPrizeDrawer
                tempTableId={tempTableId}
            />
            {/* below components are not made using shadcn, need to have a look after the new designs */}
            {showDealICMPayoutDistribution && (
                <DealMaking tempTableId={tempTableId}></DealMaking>
            )}
            {showDealConclusionPopup && (
                <DealConcluded tempTableId={tempTableId}></DealConcluded>
            )}
        </>
    )
}
